class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();
    sections.forEach(() => {
      const url = this.dataset.url;
      InfiniteScroll.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ];
  }

  static renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderPagination(html) {
    const container = document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
       document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
   
    } else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const products = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

    let productItems = Array.from(products.children);
    let totalProductsLoaded = container.children.length; // Track existing products
    let existingImages = container.querySelectorAll(".editorial-image");
    if ( existingImages) {
      totalProductsLoaded -= existingImages.length;
    }
    // Fetch the banner JSON data from the dataset
    let bannerData = JSON.parse(container.getAttribute('data-banner-json')) || [];
    const bannerInterval = parseInt(container.getAttribute("data-banner-interval")) || 8;
    const verticalImageUrl = container.getAttribute("data-vertical-images")
    const horizontalUrl = container.getAttribute("data-horizontal-images")
    const collectionName = container.getAttribute("data-collectionname").trim();
    let collectionNameTrim =  collectionName.toLowerCase()
  
    productItems.forEach((product, index) => {
        container.appendChild(product);
        totalProductsLoaded++;

        if (totalProductsLoaded % bannerInterval === 0 && bannerData.length > 0) {
          let imageIndex = (totalProductsLoaded / bannerInterval - 1); // Loop through images
          let verticalImageSrc = bannerData[imageIndex]?.vertical?.src || '';
          let horizontalImageSrc = bannerData[imageIndex]?.horizontal?.src || '';
          
          let selectedImageSrc = '';
          let achortag =''
      
          // Correct condition to handle priority and individual enable states
          if (collectionNameTrim == "vertical" && verticalImageSrc) {
              selectedImageSrc = verticalImageSrc;
              achortag = verticalImageUrl
          } else if (collectionName == "horizontal" && horizontalImageSrc) {
              selectedImageSrc = horizontalImageSrc;
              achortag = horizontalUrl

          }
      
          if (selectedImageSrc) {
              let imageElement = document.createElement('li');
              imageElement.classList.add('grid__item', 'editorial-image');
      
              // Adjust styles for horizontal images
              if (selectedImageSrc === horizontalImageSrc) {
                  imageElement.style.maxWidth = "unset";
                  imageElement.style.width = "100%";
              }
      
              imageElement.innerHTML = `
              <a href="${achortag}" target="_blank">
              <img src="${selectedImageSrc}" width="100%" height="100%" class="motion-reduce" alt="Promo Image">
              </a>
              `;
              container.appendChild(imageElement);
          }
      }
    });

    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
